const WHITE_LIST = ["_nuxt", "style-guide", "login"];

export const shouldSkipRedirectCheck = (path: string) => {
  return WHITE_LIST.some((item) => path.includes(item));
};
